import { CancelOutlined } from "@mui/icons-material";
import { Alert } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { devLog } from "utils/devLog";
import { useTranslation } from "react-i18next";

const searchTypeMap = new Map();

function ECCMemberSearchForm(props) {
  const { t } = useTranslation();
  const formRef = useRef();
  const [accessCode, setAccessCode] = useState(props.accessCode || "");
  const [firstName, setFirstName] = useState(props.firstName || "");
  const [lastName, setLastName] = useState(props.lastName || "");
  const [phoneNumber, setPhoneNumber] = useState(props.phoneNumber || "");

  const [moreThan8, setMoreThan8] = useState(false);
  const [lessThan8, setLessThan8] = useState(false);

  const [searchTypes, setSearchTypes] = useState([{ key: "ACCESS_CODE", value: t("description.DropdownOptions5") }]);

  const [selectedSearchTypes, setSelectedSearchTypes] = useState("ACCESS_CODE");

  useEffect(() => {
    devLog(selectedSearchTypes);
    setAccessCode(accessCode);
  }, [accessCode]);

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        accessCode: accessCode,
        searchType: selectedSearchTypes,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();

    if (accessCode.length < 8) {
      setMoreThan8(true);
      return;
    }

    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        accessCode: accessCode,
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        searchType: selectedSearchTypes,
      });
    }
    return false;
  };

  const vinInputLength = (e) => {
    setMoreThan8(false);
    if (e.target.value.length > 8) {
      e.target.value = e.target.value.slice(0, -1);
      setMoreThan8(true);
      devLog("Vin Length error");
    }
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          {/* <Dropdown
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle
              style={{ color: "white" }}
              variant="dark"
              id="dropdown-basic"
            >
              {searchTypes.find((opt) => opt.key == selectedSearchTypes)?.value}
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchTypes}
                    onClick={(e) => setSelectedSearchTypes(searchType.key)}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown> */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
              background: "#303030",
              color: "white",
              padding: "6px 12px 6px 12px",
              border: "1px solid rgba(0, 0, 0, 0.15)",
              borderRadius: ".25rem",
            }}
          >
            {t("description.DropdownOptions5")}
          </div>

          {/*Access Code*/}
          {selectedSearchTypes === "ACCESS_CODE" && (
            <>
              <div className="group-1">
                <div className="label">{t("description.DropdownOptions5")}:</div>
                <input
                  type="text"
                  placeholder={t("description.AccessCodeEx")}
                  name="accessCode"
                  className="input form-control required"
                  value={accessCode}
                  onChange={(e) => {
                    vinInputLength(e);
                    setAccessCode(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
              {moreThan8 && <Alert severity="error">{t("description.AccessCodeInputErrorMsg")}</Alert>}
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default ECCMemberSearchForm;
